/* eslint-disable import/prefer-default-export */
/**
 * functions here returns true if form is valid and false otherwise
 *
 * @export
 * @class Validator
 */
export class Validator {
    /**
     *
     *
     * @static
     * @param {Object} values - contains input values for create virtual component
     * @returns
     * @memberof Validator
     */
    static createVirtualComponent(values) {
        const errors = [];
        const required = ['name', 'assigneeType'];

        const requiredLength = ['projects'];

        const names = {
            name: 'Name',
            projects: 'Projects',
            defaultAssignee: 'Default assignee',
        };

        required.forEach((field) => {
            if (!values[field]) errors.push(`Field ${names[field]} is required.`);
        });

        requiredLength.forEach((field) => {
            if (!values[field].length) errors.push(`Field ${names[field]} should have at least one item selected.`);
        });

        return { isValidated: !errors.length, errors };
    }
}
